import React from "react";

// Layouts
import MainLayout from "layouts/Main";

// Components
import { Button } from "@octopus-investments/deep-sea-components";

// Styles
import "./ContinueToAccountOrLogoutPage.scss";

export default function ContinueToAccountOrLogout() {
  const handleContinueToAccountButton = () => {
    window.location.href = process.env.REACT_APP_WELCOME_BTN_URL;
  };

  return (
    <MainLayout>
      <div className="continue-to-account-content ta-l">
        <h1 className="coheadline navyBlue">Access our online services</h1>
        <p>Access valuations and documents anytime through our online portal.</p>
        <div className="buttons-block">
          <form
            action="/Interaction/Logout"
            encType="application/x-www-form-urlencoded"
            method="post"
          >
            <input
              name="logoutId"
              type="hidden"
              value={new URLSearchParams(window.location.search).get("logoutId") || ""}
            />
            <Button label="Log out" type="submit" variant="outline" />
          </form>
          <Button
            label="Continue to account"
            onClick={handleContinueToAccountButton}
            type="submit"
            variant="solid"
          />
        </div>
      </div>
    </MainLayout>
  );
}
